/* AFTER40 — Rappels : notifications sur le téléphone (lives, séances à la maison) et agenda personnel à s'abonner.
   S'affiche dans tout bloc [data-a40-rappels]. */
(() => {
  const A40 = window.A40 || { proxy: '/apps/after40' };
  const $ = (s, r = document) => r.querySelector(s);
  async function api(path, { method = 'GET', body } = {}) {
    try {
      const res = await fetch(A40.proxy + path, { method, credentials: 'same-origin', headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined });
      let data = {}; try { data = await res.json(); } catch (e) { /* */ }
      return { ok: res.ok, status: res.status, data };
    } catch (e) { return { ok: false, status: 0, data: {} }; }
  }
  function el(tag, attrs = {}, kids = []) {
    const n = document.createElement(tag);
    for (const [k, v] of Object.entries(attrs)) { if (v == null || v === false) continue; if (k === 'text') n.textContent = v; else if (k === 'class') n.className = v; else if (k.startsWith('on')) n.addEventListener(k.slice(2), v); else n.setAttribute(k, v === true ? '' : v); }
    [].concat(kids).forEach((c) => { if (c != null && c !== false) n.append(c); });
    return n;
  }
  const b64 = (s) => { const p = '='.repeat((4 - (s.length % 4)) % 4); const raw = atob((s + p).replace(/-/g, '+').replace(/_/g, '/')); return Uint8Array.from([...raw].map((c) => c.charCodeAt(0))); };
  const ios = /iphone|ipad|ipod/i.test(navigator.userAgent);
  const standalone = matchMedia('(display-mode: standalone)').matches || navigator.standalone;
  const supported = 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
  const JOURS = ['L', 'M', 'M', 'J', 'V', 'S', 'D'];
  const JOURS_LONG = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];

  async function registration() {
    return navigator.serviceWorker.register(A40.proxy + '/push/sw.js', { scope: A40.proxy + '/push/' });
  }
  async function currentSub() {
    if (!supported) return null;
    try { const reg = await navigator.serviceWorker.getRegistration(A40.proxy + '/push/'); return reg ? await reg.pushManager.getSubscription() : null; } catch (e) { return null; }
  }

  async function mount(box) {
    const r = await api('/rappels');
    if (!r.ok) { box.hidden = true; return; }
    let st = r.data;
    const icon = box.dataset.icon || '';
    const status = el('p', { class: 'a40-small a40-rappels__status', role: 'status' });
    const notifBtn = el('button', { type: 'button', class: 'a40-btn a40-btn--sm' });
    const testBtn = el('button', { type: 'button', class: 'a40-linkbtn', text: 'Envoyer une notification de test', hidden: true });
    const offBtn = el('button', { type: 'button', class: 'a40-linkbtn', text: 'Désactiver sur ce téléphone', hidden: true });

    async function paintNotif() {
      const sub = await currentSub();
      const perm = supported ? Notification.permission : 'unsupported';
      testBtn.hidden = offBtn.hidden = !sub;
      notifBtn.hidden = !!sub;
      if (!supported && ios && !standalone) { status.textContent = 'Sur iPhone : ajoute d’abord AFTER40 à ton écran d’accueil (bouton Partager → « Sur l’écran d’accueil »), ouvre l’appli depuis l’icône, puis active les notifications ici.'; notifBtn.hidden = true; return; }
      if (!supported) { status.textContent = 'Ce navigateur ne gère pas les notifications. Utilise l’agenda ci-dessous pour être prévenu.'; notifBtn.hidden = true; return; }
      if (perm === 'denied') { status.textContent = 'Les notifications sont bloquées pour AFTER40. Autorise-les dans les réglages du navigateur (cadenas à côté de l’adresse), puis reviens ici.'; notifBtn.hidden = true; return; }
      status.textContent = sub ? '✅ Notifications activées sur ce téléphone.' : 'Reçois un rappel avant chaque live et à l’heure de ta séance à la maison.';
      notifBtn.textContent = '🔔 Activer les notifications sur ce téléphone';
    }
    notifBtn.addEventListener('click', async () => {
      notifBtn.disabled = true;
      try {
        const perm = await Notification.requestPermission();
        if (perm !== 'granted') { await paintNotif(); return; }
        const reg = await registration();
        await navigator.serviceWorker.ready;
        const sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64(st.cle) });
        const res = await api('/push/abonner', { method: 'POST', body: { sub: sub.toJSON(), icon } });
        if (res.ok) await api('/push/test', { method: 'POST' });
      } catch (e) { status.textContent = 'Activation impossible sur ce téléphone pour le moment. Réessaie, ou utilise l’agenda ci-dessous.'; }
      notifBtn.disabled = false;
      await paintNotif();
    });
    testBtn.addEventListener('click', async () => { const res = await api('/push/test', { method: 'POST' }); status.textContent = res.ok ? 'Notification envoyée : regarde ton téléphone 📱' : 'Envoi impossible pour le moment.'; });
    offBtn.addEventListener('click', async () => { const sub = await currentSub(); if (sub) { await api('/push/desabonner', { method: 'POST', body: { endpoint: sub.endpoint } }); try { await sub.unsubscribe(); } catch (e) { /* */ } } await paintNotif(); });

    // Préférences de rappel
    const saveMsg = el('span', { class: 'a40-small a40-muted', role: 'status' });
    let tSave = 0;
    const save = () => { clearTimeout(tSave); tSave = setTimeout(async () => { const res = await api('/rappels', { method: 'POST', body: { lives: lives.checked, maison: { actif: maison.checked, heure: heure.value, jours: planning ? 'planning' : [...days] } } }); if (res.ok) { st = { ...st, ...res.data }; saveMsg.textContent = 'Enregistré ✓'; setTimeout(() => { saveMsg.textContent = ''; }, 1600); } }, 350); };
    const lives = el('input', { type: 'checkbox' }); lives.checked = st.lives !== false; lives.addEventListener('change', save);
    const maison = el('input', { type: 'checkbox' }); maison.checked = st.maison.actif !== false; maison.addEventListener('change', () => { detail.hidden = !maison.checked; save(); });
    const heure = el('input', { type: 'time', class: 'a40-input a40-rappels__time', value: st.maison.heure || '18:30', step: '300' }); heure.addEventListener('change', save);
    let planning = st.maison.jours === 'planning';
    const days = new Set(planning ? st.joursPlanifies || [] : st.maison.jours || []);
    const chips = el('div', { class: 'a40-rappels__days' });
    const planBtn = el('button', { type: 'button', class: 'a40-rappels__plan' });
    function paintDays() {
      chips.replaceChildren(...JOURS.map((j, i) => el('button', { type: 'button', class: 'a40-rappels__day' + (days.has(i + 1) ? ' is-on' : ''), 'aria-pressed': String(days.has(i + 1)), 'aria-label': JOURS_LONG[i], text: j, onclick: () => { planning = false; if (days.has(i + 1)) days.delete(i + 1); else days.add(i + 1); if (!days.size) { planning = true; (st.joursPlanifies || []).forEach((d) => days.add(d)); } paintDays(); save(); } })));
      planBtn.textContent = planning ? '✓ Selon mon planning À la maison' : 'Revenir à mon planning À la maison';
      planBtn.classList.toggle('is-on', planning);
    }
    planBtn.addEventListener('click', () => { planning = true; days.clear(); (st.joursPlanifies || []).forEach((d) => days.add(d)); paintDays(); save(); });
    paintDays();
    const detail = el('div', { class: 'a40-rappels__detail', hidden: !maison.checked }, [
      el('label', { class: 'a40-rappels__row' }, [el('span', { text: 'À quelle heure ?' }), heure]),
      chips, planBtn
    ]);

    // Agenda
    const url = st.agenda;
    const webcal = url.replace(/^https?:/, 'webcal:');
    const copyBtn = el('button', { type: 'button', class: 'a40-linkbtn', text: 'Copier le lien (Outlook, autre agenda)', onclick: async () => { try { await navigator.clipboard.writeText(url); copyBtn.textContent = 'Lien copié ✓'; } catch (e) { prompt('Copie ce lien dans ton agenda :', url); } } });

    box.replaceChildren(
      el('div', { class: 'a40-row', style: 'justify-content: space-between; align-items: baseline; gap: 10px;' }, [el('strong', { class: 'a40-title a40-title--md', style: 'font-size: 24px; margin: 0;', text: '🔔 Rappels & agenda' }), saveMsg]),
      el('div', { class: 'a40-rappels__block' }, [el('span', { class: 'a40-kicker', text: 'Notifications sur mon téléphone' }), status, el('div', { class: 'a40-row', style: 'gap: 12px; align-items: center;' }, [notifBtn, testBtn, offBtn])]),
      el('div', { class: 'a40-rappels__block' }, [
        el('label', { class: 'a40-check' }, [lives, el('span', { text: 'Me prévenir des lives (1 h avant et au démarrage)' })]),
        el('label', { class: 'a40-check' }, [maison, el('span', { text: 'Me rappeler ma séance à la maison' })]),
        detail
      ]),
      el('div', { class: 'a40-rappels__block' }, [
        el('span', { class: 'a40-kicker', text: 'Dans mon agenda' }),
        el('p', { class: 'a40-small a40-muted', style: 'margin: 0;', text: 'Les lives et tes séances à la maison s’ajoutent à ton agenda et se mettent à jour tout seuls, avec une alerte avant chaque séance.' }),
        el('div', { class: 'a40-row', style: 'gap: 8px;' }, [
          el('a', { class: 'a40-btn a40-btn--sm a40-btn--ghost', href: webcal, text: ios ? ' iPhone / Apple Calendrier' : 'Apple Calendrier' }),
          el('a', { class: 'a40-btn a40-btn--sm a40-btn--ghost', href: 'https://calendar.google.com/calendar/r?cid=' + encodeURIComponent(webcal), target: '_blank', rel: 'noopener', text: 'Google Agenda' })
        ]),
        copyBtn
      ])
    );
    await paintNotif();
  }

  document.addEventListener('DOMContentLoaded', () => { document.querySelectorAll('[data-a40-rappels]').forEach((b) => mount(b).catch((e) => console.error('[A40 rappels]', e))); });
})();
